import React from 'react';
import ListView from "../components/List/BookingList";
import { useTranslation } from 'react-i18next';

export default function AllBookings() {
    const { t } = useTranslation();

    return (
        <div className="flex-1 flex flex-col min-h-0">
            <h2 className="py-1 pb-3 sm:pb-4 text-xl sm:text-2xl font-gilroy font-semibold text-[#263238] shrink-0">
                {t("adminBookings.title", "Bookings")}
            </h2>
            <div className="bg-white flex-1 min-h-[380px] rounded-md overflow-hidden flex flex-col shadow-sm">
                <ListView/>
            </div>
        </div>
    );
}
